import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  incentiveTripBannerCoachGoalRank,
  incentiveTripBannerCurrentDate,
  incentiveTripBannerEndDate,
  incentiveTripBannerFQV,
  incentiveTripBannerNewCoachCount,
  incentiveTripBannerOE,
  incentiveTripBannerPath,
  incentiveTripBannerRankAchievements,
  incentiveTripBannerSupportPathCount,
  incentiveTripBonusBannerById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {withProps} from '/util/selector.util';

import {IncentiveTripBannerConnected as IncentiveTripBanner} from './IncentiveTripBanner';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    incentiveTripBonusBannerById: withCurrentUserCoachId(
      incentiveTripBonusBannerById,
    ),
    path: withCurrentUserCoachId(incentiveTripBannerPath),
    coachGoalRank: withCurrentUserCoachId(incentiveTripBannerCoachGoalRank),
    orderingEntities: withCurrentUserCoachId(incentiveTripBannerOE),
    rankAchievements: withCurrentUserCoachId(
      incentiveTripBannerRankAchievements,
    ),
    fqv: withCurrentUserCoachId(incentiveTripBannerFQV),
    currentDate: withCurrentUserCoachId(incentiveTripBannerCurrentDate),
    endDate: withCurrentUserCoachId(incentiveTripBannerEndDate),
    newCoachCount: withCurrentUserCoachId(incentiveTripBannerNewCoachCount),
    supportPathCount: withCurrentUserCoachId(
      incentiveTripBannerSupportPathCount,
    ),
    featureFlag: variablesFeatureFlag,
  }),
)(IncentiveTripBanner);
